<template>
  <div class="upload">
    <Header :hasBack="goback">
      <template slot="right">
        <!-- <el-button type="text" @click="switchPreview(1)">Krona View</el-button> -->
        <a :href="downLoadUrl" :download="downloadName">
          <i
            class="el-icon-download"
            style="font-size: 24px; cursor: pointer"
            title="download txt"
          ></i
        ></a>
        <el-button type="text" @click="switchPreview(2)">OTU Profile({{ name }})</el-button>
        <el-button type="text" @click="switchPreview(3)">Similar Profile</el-button>
      </template>
    </Header>
          <!-- name="loadiframe"
          id="iframe" -->
    <div class="upload-scroll">
      <div class="upload-body">
        <iframe
          id="iframeContain"
          ref="iframeContain1"
          name="iframeContain"
          :src="pathUrl"
          frameborder="0"
          width="100%"
          height="100%"
          @load="iframeLoad"
          @error="onIframeError"
        ></iframe>
      </div>
      <Footer style="width: 1170px; margin: auto" />
    </div>
    <!-- <img :src="imgSrc" alt="" style="width: 100px; height: 100px" /> -->
<!--     <button @click="downloadImg">download</button>
 -->  </div>
</template>

<script>
import Header from './common/header.vue'
import Footer from './common/footer.vue'
import html2canvas from 'html2canvas'

// const path = require('path')

export default {
  name: 'detail_krona',
  props: {
    msg: String
  },
  components: { Footer, Header },
  data () {
    return {
      userID: '',
      procID: '',
      pathUrl: '',
      name: '',
      fileName: '',
      goback: false,
      // logoImage: this.globalUrl + '/dist/static/img/krona-logo.png',
      downLoadUrl: '',
      outTime: 5000,
      downloadName: '',
      previewType: 1
    }
  },
  created () {
  },
  mounted () {
    let params = JSON.parse(decodeURIComponent(this.$route.query.key))
    console.log('this.$route.query.key: ', this.$route.query.key)
    this.userID = params.userid
    let procid = params.procid
    let name = params.name
    let fileName = params.fileName
    // let goback = params.goback
    console.log('this.userID: ', this.userID)
    console.log('procid: ', procid)
    console.log('name: ', name)
    this.procID = procid
    this.name = name
    this.fileName = fileName
    this.getData(procid, name)
    this.downLoadUrl = this.globalUrl + '/downloadoutfile?userID=' + this.userID + '&procID=' + procid + '&name=' + name
  },
  methods: {
    getData (procID, name) {
      this.switchPreview(1)
      // this.pathUrl = this.globalUrl + '/outhtml?userID=' + this.userID + '&procID=' + procID + '&name=' + name
      console.log('this.pathUrl:', this.pathUrl)
    },
    // #region *******************生成图片******************************** *//

    async createPic1 () {
      let imageDom = document.getElementById('iframeContain') // this.$refs.imageDom
      var rect = imageDom.getBoundingClientRect() // 获取元素相对于视口的
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop// 获取滚动轴滚动的长度
      let scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft
      let canvas = await html2canvas(imageDom, {
        x: rect.left, // 绘制的dom元素相对于视口的位置
        y: rect.top,
        logging: true, // 日志开关，便于查看html2canvas的内部执行流程
        width: imageDom.offsetWidth, // dom 原始宽度
        height: imageDom.offsetHeight,
        scrollX: scrollLeft, // 滚动的长度
        scrollY: -scrollTop,
        backgroundColor: 'transparent',
        allowTaint: true,
        useCORS: true
      })
      let acupointImgUrl = canvas.toDataURL('image/png')
      // this.acupointImgUrl = acupointImgUrl
      // return
      // this.uploadImg(acupointImgUrl, 'xwpf'+acupointItem.peId+'.png', acupointItem.peId)

      // // 转成图片，生成图片地址
      this.fileDownload(acupointImgUrl, '1111')
    },
    async createPic () {
      const iframeHtml = this.$refs.iframeContain1.contentWindow // 获取iframe内容
      const iframeBody = iframeHtml.document.getElementsByTagName('body')[0]
      const iframCanvas = iframeBody.getElementsByTagName('canvas')[0]
      let that = this
      html2canvas(iframCanvas).then(canvas => {
        // 转成图片，生成图片地址
        // let imgBase64 = canvas.toDataURL('image/png')
        // if (imgBase64) {
        //   // resolve(imgBase64)
        //   that.fileDownload(imgBase64, '1111')
        // } else {
        //   console.log('图片转换出错')
        //   // reject(new Error('图片转换出错'))
        // }

        canvas.toBlob(blob => {
          that.uploadImgNetwork(blob)
        }, 'image/png')
      })
    },
    // 下载图片
    fileDownload (downloadUrl, name) {
      let aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = downloadUrl
      aLink.download = `详情图${name}.png`
      // 触发点击-然后移除
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
    },
    // iframeload成功后生成图片
    iframeLoad () {
      console.log('iframeLoadiframeLoadiframeLoad')
      console.log(this.pathUrl)
      if (this.previewType !== 1) {
        return
      }
      if (!this.pathUrl) {
        return
      }
      setTimeout(() => {
        this.createPic()
      }, 2500)
    },
    async uploadImgNetwork (blob) {
      try {
        const formData = new FormData()
        formData.append('file', blob, 'screenshot.png')
        formData.append('procID', this.procID)
        formData.append('name', 'screenshot.png')
        const res = await this.axios.post('/kssd/uploadImg', formData, {
          headers: {
            'UserID': this.userID,
            'Content-Type': 'multipart/form-data'
          }
        })
        console.log('图片上传结果')
        console.log(res)
        if (res.data.retCode < 0) {
          this.$message({
            showClose: true,
            message: 'Snapshot upload failed!',
            type: 'error'
          })
        } else {
          this.$message({
            showClose: true,
            message: 'Snapshot has been uploaded!',
            type: 'success'
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    onIframeError (err) {
      console.error('Failed to load iframe')
      console.log(err)
    },
    // #endregion *******************生成图片******************************** *//

    // #region *******************切换预览内容******************************** *//
    switchPreview (type) {
      this.previewType = type
      if (type === 1) {
        this.pathUrl = this.globalUrl + '/outhtml?userID=' + this.userID + '&procID=' + this.procID + '&name=' + this.name
      } else if (type === 2) {
        const url = this.globalUrl + '/outfile?userID=' + this.userID + '&procID=' + this.procID + '&name=' + this.name
        window.open(url, '_blank')
      } else if (type === 3) {
        const url = this.globalUrl + '/outabv?userID=' + this.userID + '&procID=' + this.procID + '&name=' + this.name + '&fileName=' + this.fileName
        window.open(url, '_blank')
      }
    }
    // #endregion *******************切换预览内容******************************** *//
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.upload {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.upload-scroll {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
.upload-body {
  flex: 1;
  max-width: 1170px;
  margin: auto;
  width: 100%;
  min-height: 1px;
  text-align: left;
  min-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/detail_krona.vue